import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { setSidebarOpen } from 'app/providers/uiSlice';

const STORAGE_KEY = 'takshify-sidebar-open-v2';

export function useSidebarPersist() {
  const dispatch = useAppDispatch();
  const sidebarOpen = useAppSelector((s) => s.ui.sidebarOpen);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved !== null) {
        dispatch(setSidebarOpen(saved === 'true'));
      }
    } catch {
      // Ignore storage errors (private browsing, etc.)
    }
  }, [dispatch]);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(sidebarOpen));
    } catch {
      // Ignore storage errors
    }
  }, [sidebarOpen]);

  return sidebarOpen;
}
